<template>
  <div class="main"  v-if='attendanceList.length > 0'>
      <div v-for="(item, index) in attendanceList" :key="index" class="contents">
        <transition
          :appear="true"
          @after-leave="handleLeave"
          name="el-fade-in-linear"
        >
          <div v-show="item.isShow=='1'" class="transition-box">
            <div class="avatars">
              <img :src="item.imageUrl" class='image' />
            </div>
            <div class="information">
                <div>{{ item.name ? item.name : '未知'}}</div>
                <div> 
                  <span :class="item.direction == '01' ? 'text-darkgreen':'text-red' ">
                    {{item.direction == '01' ? '进场':'出场'}}
                  </span>
                </div>
                <div>班组名称:{{ item.teamName}}</div>
                <div>工种:{{ item.type ? item.type : '未定义' }}</div>
                <div>{{ item.date }}</div>
            </div>
          </div>
        </transition>
      </div>
  </div>
      <div v-else  class='text-white main empty'>
        暂无考勤信息
    </div>
</template>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  background: rgba(47, 79, 79, 0.1);
  /* overflow: hidden; */
}
.image{
  width:90%;
  height:90%;
}
.empty{
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size:2em;
}
.contents {
  width: 100%;
  height: 20%;
  border-top: 2px solid #87cefa;
}
.text-darkgreen {
  color: #7fffd4;
}
.transition-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.avatars {
  width:50%;
  height: 100%;
  display:flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-around;
}
.information {
  padding: 0 0 0 10px;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.information div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width:100%;
  font-size: 16px;
  color: #87cefa;
  &:nth-child(1){
    font-size: 23px;
  }
  &:nth-child(2){
    font-size: 20px;
  }
}
</style>
<script>
// import '../../assets/rem'
export default {
  data() {
    return {
      attendanceList: [ ],
      newData  : [],
    };
  },
  methods: {
    add(needSplice) {
      if(this.newData.length > 0){
        if(this.attendanceList.length < 5){
          this.handleLeave();
        }else{
          this.$set(this.attendanceList[this.attendanceList.length - 1], "isShow", '0');
        }
      }
    },
    changeData(newData){
      this.newData = [...newData,...this.newData];
    },
    handleLeave() {
      this.attendanceList.unshift(this.newData[this.newData.length-1]);
      this.newData.splice(-1,1);
      if(this.attendanceList.length > 5){
        this.attendanceList.splice(-1);
      }
    },
  },
  mounted() {
    setInterval(this.add, 1000);
  },
};
</script>
